import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const InviteApi = createApi({
  reducerPath: "InviteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + `users/invite`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  endpoints: (builder) => ({
    inviteUser: builder.mutation({
      query: ({ phoneNumber, fullname } = {}) => {
        const payload = {};

        if (fullname != null) payload.fullname = fullname;
        if (phoneNumber != null) payload.phone = phoneNumber;

        return {
          url: "",
          method: "POST",
          body: payload,
        };
      },
    }),
    getInviteCard: builder.query({
      query: ({ id }) => {
        return {
          url: `/${id}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useInviteUserMutation, useGetInviteCardQuery } = InviteApi;
